/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Checkbox, FormControlLabel, Menu, MenuItem } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
function VehiclesMenu() {

    const location = useLocation();
    const navigate = useNavigate();

    const [selectedVehicleTypes, setSelectedVehicleTypes] = useState([]);
    const [anchor, setAnchor] = useState(null);
    const open = Boolean(anchor);
    const [mainData, setMainData] = useState({});
    const formReducer = useSelector((state) => state.form);






    const updateURLQuery = () => {
        if (anchor) {

            const searchParams = new URLSearchParams(location.search);
            if (selectedVehicleTypes.length === 0) {
                searchParams.delete('Vehicles');
            } else {
                searchParams.set('Vehicles', selectedVehicleTypes.join(','));
            }
            navigate({ search: searchParams.toString() });
        }
    };





    useEffect(() => {
        if (formReducer.loading === 'succeeded') {
            setMainData(formReducer.data);
        }

        const searchParams = new URLSearchParams(location.search);
        const vehiclesParam = searchParams.get('Vehicles');

        if (vehiclesParam === null) {
            setSelectedVehicleTypes([]);
        } else {
            const selectedTypes = vehiclesParam.split(',').map(Number);
            setSelectedVehicleTypes(selectedTypes);
        }
    }, [formReducer.loading, location.search]);









    useEffect(() => {
        updateURLQuery();
    }, [selectedVehicleTypes]);







    const handleClick = (event) => {


        setAnchor(event.currentTarget);
    };
    const handleClose = (e) => {

        setAnchor(null);
    };

    const handleCheckboxChange = (event) => {
        const vehicleTypeId = Number(event.target.value);
        const isChecked = event.target.checked;

        if (isChecked && vehicleTypeId === 0) {
            setSelectedVehicleTypes([]);
        } else {
            if (isChecked) {
                setSelectedVehicleTypes((prevSelectedTypes) => [...prevSelectedTypes, vehicleTypeId]);
            } else {
                setSelectedVehicleTypes((prevSelectedTypes) => prevSelectedTypes.filter((id) => id !== vehicleTypeId));
            }
        }
    };


    return (
        <Box className='VehiclesType'>
            <Box >
                <Button
                    id="VehiclesType"
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}

                >
                    Vehicles Type
                    {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </Button>
            </Box>
            <Menu
                id="basic-menu"
                anchorEl={anchor}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                PaperProps={{
                    style: {
                        width: '85%',
                        maxWidth: '100%',
                        maxHeight: '300px',
                        left: 0,
                        right: 0,
                    },
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap', width: "100%", maxHeight: '300px', overflow: 'auto', overflowY: 'hidden' }}>
                    <MenuItem>
                        <FormControlLabel
                            label="All Vehicles"
                            control={<Checkbox checked={selectedVehicleTypes.length === 0} value={0} onChange={handleCheckboxChange} />}
                        />
                    </MenuItem>

                    {mainData.vehicleTypeList?.map((item) => (
                        <MenuItem key={item.id}>
                            <FormControlLabel
                                label={item.name}
                                control={<Checkbox checked={selectedVehicleTypes.includes(item.id)} value={item.id} onChange={handleCheckboxChange} />}
                            />
                        </MenuItem>
                    ))}
                </Box>
            </Menu>
        </Box>


    )
}

export default VehiclesMenu